var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExportTemplatesService, PersonalizedTemplate, Template, } from '@synisys/idm-export-templates-service-client-js';
import { cloneDeep } from 'lodash';
import { of } from 'rxjs/observable/of';
import { first, map, tap } from 'rxjs/operators';
import { noop } from 'rxjs/util/noop';
import { createLogger } from '../utilities';
import { TemplateBuilderCommunicationService } from './template-builder-communication.service';
import './dynamic-template-editor.component.scss';
var LOGGER = createLogger('dynamic-template-editor');
var DynamicTemplateEditorComponent = /** @class */ (function () {
    function DynamicTemplateEditorComponent(templateBuilderCommunicationService, exportTemplatesService) {
        this.templateBuilderCommunicationService = templateBuilderCommunicationService;
        this.exportTemplatesService = exportTemplatesService;
        this.closeDrawer = new EventEmitter();
    }
    Object.defineProperty(DynamicTemplateEditorComponent.prototype, "template", {
        get: function () {
            return this._template;
        },
        set: function (value) {
            this._template = cloneDeep(value);
        },
        enumerable: true,
        configurable: true
    });
    DynamicTemplateEditorComponent.prototype.ngOnInit = function () {
        this.templateBuilderCommunicationService.setIdentity(this.instanceId, this.category);
    };
    DynamicTemplateEditorComponent.prototype.templateChange = function (item) {
        if (item instanceof PersonalizedTemplate) {
            this.templateToSave = item;
        }
        else {
            LOGGER.error("sis-multilingual-template-editor's emitted " +
                "value is not PersonalizedTemplate");
        }
    };
    DynamicTemplateEditorComponent.prototype.onClose = function () {
        this.close();
    };
    DynamicTemplateEditorComponent.prototype.onSaveEvent = function () {
        this.save()
            .pipe(first())
            .subscribe(noop, LOGGER.error);
    };
    DynamicTemplateEditorComponent.prototype.onSaveCloseEvent = function () {
        var _this = this;
        this.save()
            .pipe(first(), tap(function () { return _this.close(); }))
            .subscribe(noop, LOGGER.error);
    };
    DynamicTemplateEditorComponent.prototype.save = function () {
        var _this = this;
        if (this.templateToSave) {
            return this.exportTemplatesService
                .updatePersonalizedTemplate(this.templateToSave)
                .pipe(map(function (template) {
                _this._template = template;
                _this.templateToSave = undefined;
            }));
        }
        return of(undefined);
    };
    DynamicTemplateEditorComponent.prototype.close = function () {
        this.closeDrawer.emit();
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DynamicTemplateEditorComponent.prototype, "category", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DynamicTemplateEditorComponent.prototype, "instanceId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DynamicTemplateEditorComponent.prototype, "opened", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DynamicTemplateEditorComponent.prototype, "closeDrawer", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Template),
        __metadata("design:paramtypes", [Template])
    ], DynamicTemplateEditorComponent.prototype, "template", null);
    DynamicTemplateEditorComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'dynamic-template-editor',
            template: require('./dynamic-template-editor.component.html'),
        }),
        __metadata("design:paramtypes", [TemplateBuilderCommunicationService,
            ExportTemplatesService])
    ], DynamicTemplateEditorComponent);
    return DynamicTemplateEditorComponent;
}());
export { DynamicTemplateEditorComponent };
//# sourceMappingURL=dynamic-template-editor.component.js.map